import dayjs, { Dayjs } from "dayjs";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { selectAnalytics } from "../../../../store/analytics/repository/selector";
import { getTestResults } from "../../../../store/analytics/useCases/getTestResults/action";
import { useDebounce } from "../../../../hooks/useDebounce";
import { getTestList } from "../../../../store/test/useCases/getTestList/action";
import { selectTest } from "../../../../store/test/repository/selector";

export const useUserAnalytics = () => {
    const dispatch = useDispatch();
    const [test, setTest] = useState<any>(null);
    const { testResults } = useSelector(selectAnalytics);
    const { testList } = useSelector(selectTest);

    useEffect(()=>{
        dispatch(getTestList());
    }, []);

    useEffect(()=>{
        test && dispatch(getTestResults({id: test.id}));
    }, [test]);
    
    const [dates, setDates] = useState<{ startDate: Dayjs | null, endDate: Dayjs | null }>({
        startDate: dayjs().startOf('month'),
        endDate: dayjs().endOf('month')
    });

    const handleRangeChange = (selectedDates: [start: Dayjs | null, end: Dayjs | null], dateStrings: [string, string]) => {
        if (selectedDates) {
            const [start, end] = selectedDates;
            setDates({ startDate: start, endDate: end });
        }
    };

    const disabledDate = (current: Dayjs) => {
        if (!current) {
            return false;
        }
        const { startDate, endDate } = dates;
        return false;
    };

    const handleChangeTest = useCallback((task: any) => {
        setTest(task);
    }, [setTest]);

    const changeTestText = (event: ChangeEvent<HTMLInputElement>) => {
        debouncedHandleTestSeacrh(event.target.value);
    };

    const onSearchTest = (value: string) => {
        if (value.length) {
            // getTaskDropdownList(value)
        } else {
            // getTaskDropdownList();
        }
    };

    const { debouncedWrapper: debouncedHandleTestSeacrh } = useDebounce(onSearchTest, 1000);
    
    return { dates, handleRangeChange, disabledDate, test, handleChangeTest, changeTestText, testList }
};